import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from 'components/Icon';

import css from './Checkbox.module.scss';

class Checkbox extends React.Component {
    static propTypes = {
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        children: PropTypes.node,
        onChange: PropTypes.func,
        tabbable: PropTypes.bool,
        checked: PropTypes.bool
    }

    static defaultProps = {
        checked: false,
        tabbable: true
    }

    constructor(props){
        super();

        this.state = {
            active: props.checked
        };
    }

    componentWillReceiveProps = (nextProps) =>{
        this.setState({active: nextProps.checked});
    }

    toggle = () => {
        this.setState({active: !this.state.active});
    }

    _handleClick = (e) => {
        e.preventDefault();

        this.toggle();
        this.props.onChange && this.props.onChange();
    }
    
    render(){
        let { id, children, tabbable, onChange } = this.props;
        let { active } = this.state;
        return <div 
            data-id={id}
            onClick={this._handleClick}
            onChange={onChange}
            onKeyDown={(e)=>{
                let code = e.which;
                // 13 = Return, 32 = Space
                if ((code === 13) || (code === 32)) {
                    e.stopPropagation();
                    e.preventDefault();
                    onChange(e);
                }
            }}
            tabIndex={tabbable ? 0 : -1}
            className={cn(css.block,{
                [css['active']] : active
            })}>
            <span className={css.check}><Icon icon="checkmark" /></span>
            {children}
        </div>;
    }
}

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.jsx